import createReducer from '../createReducer'
import {
  FETCH_USER_GEAR_SUCCESS,
} from './constants'

export const initialState = {
  gear: [],
}

export default createReducer(initialState, {

  name: 'usergear',

  [FETCH_USER_GEAR_SUCCESS]: (state, action) => {
    const gear = action.payload.data._embedded.usergear
    return { ...state, gear }
  },

})



// WEBPACK FOOTER //
// ./src/services/userGear/reducer.js